export default {
    rol:{},
   roles:[],
    pagination:{
        total:0,
        current_page:0,
    },
    abilities:[]
}
